import { render, staticRenderFns } from "./MassConfigurationTable.vue?vue&type=template&id=ab7e088a&"
import script from "./MassConfigurationTable.vue?vue&type=script&lang=js&"
export * from "./MassConfigurationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports